import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { IDocumentListsResult, IDocumentListsValidity } from "./types";
import { serverResponse } from "./validators";

interface IFetchDocumentListsProps {
  validity: IDocumentListsValidity | undefined;
}

export async function fetchDocumentLists({
  validity,
}: IFetchDocumentListsProps): Promise<IDocumentListsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/cms/documents/categories`,
    {
      validator: serverResponse,
      searchParams: {
        brand: "NJU",
        displayWeb: true,
        ...(validity && { validity }),
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(result.value);
}
